import { IS_ORDER_FIRED } from '../../util/actionTypes';
const initialState = {data:{}};

const placeorderReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case IS_ORDER_FIRED: 
            return {
                ...state,
                data :action.payload, 
            };   
       
        default:
            return state;
    }
};

export default placeorderReducer;
